<template>
  <div :id="loptions.id" :class="setStyleContainer(loptions.cssContainer)">
    <modal name="searchlist" :draggable="true">
      <div v-if="search_col" class="columns p-2">
        <div class="column">
          <div class="sr_bold p-3">Ricerca</div>
          <div class="control pb-3">
            <label class="radio"> Testo da ricercare </label>
            <input
              v-model="search_text"
              class="input"
              type="text"
              placeholder="testo da ricercare"
              @keyup.enter="doSearchText"
            />
          </div>
          <label class="radio"> Colonna {{ search_col.title }} </label>
          <div class="pt-6">
            <div class="footer columns">
              <div class="column has-text-centered">
                <span
                  class="button is-small is-danger buttonsize"
                  @click="closeSearch"
                  >Annulla</span
                >
              </div>
              <div class="column has-text-centered">
                <span
                  class="button is-small is-success buttonsize"
                  @click="doSearchText()"
                  >Cerca</span
                >
              </div>
            </div>
          </div>
        </div>
        <div class="column">
          <div class="sr_bold p-3">Risultati</div>
          <div class="search_box box">
            <ul id="elements" class="p-2 sr_history_table">
              <li
                v-for="item in search_elements"
                :key="item.cod"
                @click="selectSearch(item)"
                :class="[
                  search_selected !== null
                    ? search_selected.cod === item.cod
                      ? 'is-item-selected'
                      : 'is-item-not-selected'
                    : 'is-item-not-selected',
                  '',
                ]"
              >
                <div class="columns">
                  <div class="column is-narrow">
                    {{ item.targa }}
                  </div>
                  <div class="column">{{ item.cognome }} {{ item.nome }}</div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </modal>

    <div class="table-header-wrapper">
      <table
        :id="loptions.id + 'h'"
        :class="setStyleHeader(loptions.cssHeader)"
      >
        <tr @contextmenu.prevent="$refs.ctxMenu.open">
          <th
            v-for="col in lcolumns"
            :key="col.id"
            :data-column-name="col.id"
            :width="col.width ? col.width : '100'"
            :class="setStyleCell(col, 'th')"
            @click.prevent="colClick(col, row)"
          >
            {{ col.title }}

            <span v-if="col.order >= 0" class="icon is-small is-pulled-right">
              <img
                v-if="loptions.order_col === col.id"
                :src="[
                  col.order === 1
                    ? 'images/icon_sort_down_red.png'
                    : 'images/icon_sort_up_red.png',
                ]"
                @click.prevent="handleOrderDir(col)"
              />
              <img
                v-else
                :src="['images/icon_sort.png']"
                @click.prevent="handleOrderDir(col)"
              />
            </span>
            <span v-if="col.search" class="icon is-small is-pulled-right">
              <img
                :src="['images/glass.png']"
                @click.prevent="handleSearch(col)"
              />
            </span>
          </th>
        </tr>
      </table>
    </div>
    <div
      :id="loptions.id + 'bw'"
      class="table-body-wrapper"
      v-click-outside="clickOutside"
    >
      <table :id="loptions.id + 'b'" :class="setStyleBody(loptions.cssBody)">
        <tr
          v-for="row in wrows"
          :class="loptions.cssRows"
          :key="row.srampkey"
          :id="'zz' + row.cod"
        >
          <td
            v-for="col in lcolumns"
            :key="col.id"
            :width="col.width ? col.width : '100'"
            :class="setStyleCell(col, 'td', row === selectedItem, row)"
            @mouseup.prevent="colMouseup($event, loptions.id, col, row)"
            @mousedown.prevent="colMousedown($event, loptions.id, col, row)"
            @click="colClick(loptions.id, col, row, $event)"
          >
            <template v-if="col.image">
              <span class="icon is-small">
                <template v-if="col.image_name.length === 0">
                  <img :src="$parent.get_image(col.id, row[col.id], row)" />
                </template>
                <template v-else>
                  <img :src="col.image_name" />
                </template>
              </span>
            </template>
            <template v-else-if="col.checkbox">
              <input v-model="row[col.id]" type="checkbox" />
            </template>
            <template v-else>
              <div :key="colIdEdit" v-if="checkEditable(col, row)">
                <input
                  ref="inp1"
                  class="input_style"
                  type="text"
                  v-model="row[col.id]"
                  v-focus
                  v-on:keyup="doEnter($event)"
                />
              </div>
              <div v-else style="pointer-events: none">
                <template v-if="getCouple(row, col)">
                  <CellBox
                    :row="row"
                    :col="col"
                    :text="
                      formatCellValue(
                        row[col.id],
                        row[col.f_type_id],
                        col.f_type,
                        col.filter
                      )
                    "
                  />
                </template>
                <template v-else>
                  {{
                    formatCellValue(
                      row[col.id],
                      row[col.f_type_id],
                      col.f_type,
                      col.filter
                    )
                  }}
                </template>
              </div>
            </template>
          </td>
        </tr>
      </table>
    </div>
    <context-menu id="context-menu" ref="ctxMenu">
      <li @click="doSaveCookie">Salva colonne</li>
      <li @click="doResetColumns">Reset colonne</li>
    </context-menu>
  </div>
</template>
<script>
import { ServiceBus } from '../../ServiceBus.js'
import CellBox from './CellBox.vue'
import contextMenu from 'vue-context-menu'

export default {
  name: 'VueScrollTable',
  components: { contextMenu, CellBox },
  props: {
    options: {
      default: null,
      type: Object,
    },
    columns: {
      default: new Array(),
      type: Array,
    },
    rows: {
      default: new Array(),
      type: Array,
    },
    recalc: {
      default: false,
      type: Boolean,
    },
  },
  data() {
    let data = {
      loptions: { ...this.options },
      lcolumns: [...this.columns],
      windowHeight: 0,
      windowWidth: 0,
      grips: [],
      viewMenu: false,
      top: '0px',
      left: '0px',
      selectedItem: null,
      mouse_ref: null,
      mouse_bk: null,
      colIdEdit: null,
      rowIdEdit: null,
      search_col: null,
      search_text: '',
      search_elements: [],
      search_selected: null,
    }
    return data
  },
  beforeRouteLeave(to, from, next) {},
  computed: {
    wrows() {
      const vm = this
      for (let i = 0; i < vm.rows.length; i++) {
        vm.rows[i].srampkey = i
      }
      if (vm.loptions !== null || vm.loptions !== undefined) {
        let col = vm.findColByKey('id', vm.loptions.order_col)
        vm.sortRows(col)
      }
      return vm.rows
    },
  },
  watch: {
    recalc: function () {
      if (this.recalc) {
        this.recalcColumnsSize()
        this.$emit('recalc')
      }
    },
    columns: {
      immediate: true,
      handler(newVal, oldVal) {
        this.lcolumns = newVal
      },
    },
    options: {
      immediate: true,
      handler(newVal, oldVal) {
        this.loptions = newVal
      },
    },
  },
  directives: {
    focus: {
      inserted(el) {
        el.focus()
      },
    },
  },
  mounted() {
    ServiceBus.$on('scroll', (idx, theId) => {
      this.scrollToVisible(idx, theId)
    })
    ServiceBus.$on('deselect', () => {
      this.selectedItem = null
    })
    ServiceBus.$on('select', (item) => {
      this.selectedItem = item
    })
    ServiceBus.$on('selectfirst', () => {
      this.selectedItem = this.wrows[0]
    })
    ServiceBus.$on('forcesort', () => {
      this.forceSort()
    })

    this.$nextTick(function () {
      const vm = this
      vm.container = document.getElementById(vm.loptions.id)
      vm.header = document.getElementById(vm.loptions.id + 'h')
      vm.body = document.getElementById(vm.loptions.id + 'b')
      vm.overflow = document.getElementById(vm.loptions.id + 'bw')
      window.addEventListener('resize', this.getWindowSize)
      vm.getWindowSize()
      if (vm.loptions.isResizeable) {
        vm.setResizeGrips()
      }
      let a = vm.getCookie(vm.options.id)
      if (a !== '') {
        let obj = JSON.parse(a)
        vm.loptions.order_col = obj.order_col
        vm.lcolumns = obj.columns
      }
      let col = vm.findColByKey('id', vm.loptions.order_col)
      vm.sortRows(col)
    })
  },
  methods: {
    makeElementVisible(elementId) {
      // Find the element by its ID
      var element = document.getElementById(elementId)

      // Check if the element exists
      if (element) {
        // Get the parent container of the list
        var container = document.getElementById(this.loptions.id + 'bw')

        // Calculate the offset of the element relative to the container
        var offsetTop = element.offsetTop - container.offsetTop
        var offsetBottom = offsetTop + element.clientHeight

        // Check if the element is fully visible
        var containerTop = container.scrollTop
        var containerBottom = containerTop + container.clientHeight
        if (offsetTop < containerTop || offsetBottom > containerBottom) {
          // Scroll the container to make the element visible
          container.scrollTop = offsetTop
        }
      }
    },

    findStringByStartingCharacters(arr, startingChars, key) {
      const sanitizedStartingChars = startingChars
        .replace(/\s+/g, '')
        .toUpperCase() // Remove spaces
      return arr.filter((obj) => {
        if (
          typeof obj[key] === 'string' &&
          obj[key]
            .replace(/\s+/g, '')
            .toUpperCase()
            .startsWith(sanitizedStartingChars)
        ) {
          return true
        }

        return false
      })
    },

    showSearch() {
      this.$modal.show('searchlist')
    },
    closeSearch() {
      this.$modal.hide('searchlist')
    },
    selectSearch(element) {
      const vm = this
      vm.search_selected = element
      vm.makeElementVisible('zz' + element.cod)
      vm.selectedItem = element
      vm.closeSearch()
    },
    doSearchText() {
      const vm = this
      vm.search_elements = []
      vm.search_selected = null

      vm.search_elements = vm.findStringByStartingCharacters(
        vm.wrows,
        vm.search_text,
        vm.search_col.id
      )
    },

    getCouple(row, col) {
      if (col.ghostid === undefined) return false
      if (row.couple !== undefined) {
        return !Array.isArray(row.couple)
      }
      return false
    },
    checkEditable(col, row) {
      return col.id === this.colIdEdit && row.cod === this.rowIdEdit.cod
    },
    clickOutside(ev) {
      this.doSaveCell()
    },
    doEnter(event) {
      if (event.code === 'Enter' || event.code === 'NumpadEnter') {
        this.doSaveCell()
      }
      if (event.code === 'Escape') {
        this.colIdEdit = ''
        this.rowIdEdit = null
      }
    },
    doSaveCell() {
      const vm = this
      if (vm.$parent.colSaveCell) {
        vm.$parent.colSaveCell(vm.colIdEdit, vm.rowIdEdit)
      } else {
        console.log('colSaveCell is not implemented in parent')
      }
      vm.colIdEdit = ''
      vm.rowIdEdit = null
    },
    stopTheEvent(event) {
      event.stopPropagation()
    },
    doResetColumns() {
      const vm = this
      vm.$parent.initColumns()
      setTimeout(function () {
        vm.recalcColumnsSize()
      }, 40)
    },
    setCookie(cname, cvalue, exdays) {
      const d = new Date()
      d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000)
      let expires = 'expires=' + d.toUTCString()
      document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/'
    },

    getCookie(cname) {
      let name = cname + '='
      let decodedCookie = decodeURIComponent(document.cookie)
      let ca = decodedCookie.split(';')
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i]
        while (c.charAt(0) == ' ') {
          c = c.substring(1)
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length)
        }
      }
      return ''
    },
    doSaveCookie() {
      const vm = this
      let myCookie = {
        order_col: vm.loptions.order_col,
        columns: vm.lcolumns,
      }
      vm.setCookie(vm.options.id, JSON.stringify(myCookie), 1000)
    },
    setId(name) {
      const vm = this
      return vm.loptions.id + name
    },
    forceSort() {
      const vm = this
      let col = vm.findColByKey('id', vm.loptions.order_col)
      vm.sortRows(col)
    },
    sortRows(col) {
      const vm = this
      if (col !== null) {
        //let id = col.ghostid !== undefined ? col.ghostid : col.id
        let id = col.id
        if (col.ghostid !== undefined) {
          id = col.ghostid
        }
        if (col.order === 0) {
          vm.rows.sort(function (a, b) {
            return (
              (a[id] === null) - (b[id] === null) ||
              +(a[id] > b[id]) ||
              -(a[id] < b[id])
            )
          })
        } else {
          vm.rows.sort(function (a, b) {
            return (
              (a[id] === null) - (b[id] === null) ||
              -(a[id] > b[id]) ||
              +(a[id] < b[id])
            )
          })
        }
      }
    },
    findColByKey(key, value) {
      const vm = this
      for (let i = 0; i < vm.lcolumns.length; i++) {
        if (vm.lcolumns[i][key] === value) {
          return vm.lcolumns[i]
        }
      }
      return null
    },
    onMouseDown(e) {
      const vm = this
      vm.thElm = e.target.parentNode
      vm.startOffset = vm.thElm.offsetWidth - e.pageX
    },
    onMouseMove(e) {
      const vm = this
      if (vm.thElm) {
        const width = vm.startOffset + e.pageX
        vm.thElm.width = width + 'px'
        vm.syncColumnWidths()
      }
    },
    onMouseUp(e) {
      const vm = this
      vm.thElm = undefined
      //vm.syncColumnWidths()
    },
    syncColumnWidths() {
      const vm = this
      const headerCols = Array.from(vm.header.getElementsByTagName('th'))
      const widths = headerCols.map((h) => (h.width ? h.width : h.clientWidth))
      const bodyCols = Array.from(vm.body.querySelectorAll('tr:first-child>td'))
      bodyCols.forEach((c, i) => {
        this.lcolumns[i].width = parseInt(widths[i])
      })
      this.recalcColumnsSize()
    },
    colMouseup(id, col, row) {
      const vm = this
      if (vm.mouse_ref !== null) {
        vm.mouse_ref.style.backgroundColor = vm.mouse_bk
      }
      vm.mouse_ref = null
    },
    colMousedown(e, id, col, row) {
      if (col.mousefeedback === true) {
        const vm = this
        vm.mouse_ref = e.srcElement
        vm.mouse_bk = vm.mouse_ref.style.backgroundColor
        vm.mouse_ref.style.backgroundColor = 'lightgray'
      }
    },
    colClick(id, col, row, event) {
      const vm = this
      if (col.checkbox) {
        if (vm.$parent.colCheckbox) {
          vm.$parent.colCheckbox(id, col, row, event)
        } else {
          console.log('colCheckbox is not implemented in parent')
        }
        return
      }
      if (vm.loptions.isSelectable) {
        vm.selectedItem = row
        if (col.editable) {
          vm.colIdEdit = col.id
          vm.rowIdEdit = row
          return
        }
        if (vm.$parent.colClick) {
          vm.$parent.colClick(id, col, row, event)
        } else {
          console.log('colClick is not implemented in parent')
        }
      }
    },
    handleSearch(col) {
      const vm = this
      vm.search_col = col
      vm.showSearch()
    },
    handleOrderDir(col) {
      const vm = this
      vm.loptions.order_col = col.id
      col.order = 1 - col.order
      vm.sortRows(col)
    },
    setResizeGrips() {
      const vm = this
      const headerCols = Array.from(vm.header.getElementsByTagName('th'))
      headerCols.forEach((th) => {
        th.style.position = 'relative'
        const grip = document.createElement('div')
        grip.className = 'grip'
        grip.innerHTML = '&nbsp'
        grip.style.top = 0
        grip.style.right = 0
        grip.style.bottom = 0
        grip.style.width = '5px'
        grip.style.position = 'absolute'
        grip.style.cursor = 'col-resize'
        grip.addEventListener('mousedown', vm.onMouseDown)
        th.appendChild(grip)
        vm.grips.push(grip)
      })
      document.addEventListener('mousemove', vm.onMouseMove)
      document.addEventListener('mouseup', vm.onMouseUp)
    },
    setStyleContainer(sContainer) {
      if (
        sContainer === null ||
        sContainer === undefined ||
        sContainer === ''
      ) {
        sContainer = 'table-container'
      }
      return sContainer
    },
    setStyleHeader(sHeader) {
      if (sHeader === null || sHeader === undefined || sHeader === '') {
        sHeader = 'table-header'
      }
      return sHeader
    },
    setStyleBody(sBody) {
      if (sBody === null || sBody === undefined || sBody === '') {
        sBody = 'table-body'
      }
      return sBody
    },
    setStyleCell(colObj, cellType, isSelected, data) {
      let alignmentSet
      let styleSet
      let color = ''
      let cursorstyle = ''
      if (cellType == 'th') {
        alignmentSet = colObj.alignment_th
        styleSet = colObj.style_th
      } else {
        alignmentSet = colObj.alignment_td
        styleSet = colObj.style_td
      }
      if (
        alignmentSet === null ||
        alignmentSet === undefined ||
        alignmentSet === ''
      ) {
        alignmentSet = 'left_align'
      }
      if (styleSet === null || styleSet === undefined || styleSet === '') {
        styleSet = 'cell'
      }
      cursorstyle = 'arrowcursor'
      if (typeof colObj.mousefeedback !== 'undefined') {
        if (colObj.mousefeedback === true) {
          cursorstyle = 'handcursor'
        }
      }
      if (colObj.calcColor && cellType === 'td') {
        switch (data.mode) {
          case '2':
            color = 'sr_black'
            break
          case '1':
            color = 'sr_red'
            break
          case '0':
            color = 'sr_green'
            break
        }
      } else {
        color = 'sr_black'
      }

      if (cellType === 'th') {
        return alignmentSet + ' ' + styleSet
      } else {
        if (isSelected) {
          return (
            alignmentSet +
            ' ' +
            styleSet +
            ' ' +
            'isSelected' +
            ' ' +
            color +
            ' ' +
            cursorstyle
          )
        } else {
          return alignmentSet + ' ' + styleSet + ' ' + color + ' ' + cursorstyle
        }
      }
    },
    formatCellValue(value, value_f_type, col_f_type, filter) {
      let res = value
      let dd
      if (value === null) return ''

      if (col_f_type === '*' || value_f_type === col_f_type) {
        switch (filter) {
          case 'mssg_filter':
            res = value.split('[')[0]
            break
          case 'pipe_filter':
            res = value.replace(/\|/g, ' ')
            break
          //case 'date_reverse_filter':
          //	dd = value.split(" ");
          //	res = dd[0].split("-").reverse().join("-") + " " + dd[1]
          //	break
          //case 'date_reverse_solo_filter':
          //	dd = value.split(" ");
          //	res = dd[0].split("-").reverse().join("-")
          //	break
          case 'num.########':
            res = value.toLocaleString(undefined, { maximumFractionDigits: 8 })
            break
          case 'num.####':
            res = value.toLocaleString(undefined, { maximumFractionDigits: 4 })
            break
          case 'num.#':
            res = value.toLocaleString(undefined, { maximumFractionDigits: 1 })
            break
          case 'date_reverse_filter':
            dd = value.split(' ')
            res = dd[0].split('-').reverse().join('-') + ' ' + dd[1]
            break
          case 'date_reverse_t_filter':
            dd = value.split('T')
            res = dd[0].split('-').reverse().join('-') + ' ' + dd[1]
            break
          case 'date_reverse_solo_filter':
            dd = value.split(' ')
            res = dd[0].split('-').reverse().join('-')
            break
        }
        return res
      } else {
        return ''
      }
    },
    recalcColumnsSize() {
      const vm = this
      let sumColsLength = 0
      let delta
      let elastic = []
      for (let i = 0; i < vm.lcolumns.length; i++) {
        sumColsLength += vm.lcolumns[i].width
        if (vm.lcolumns[i].elastic) {
          elastic.push(vm.lcolumns[i])
        }
      }
      delta = vm.windowWidth - 16 - sumColsLength
      if (delta === 0) return
      if (elastic.length > 0) {
        if (elastic.length > 1) {
          elastic.sort(function (a, b) {
            return a.width > b.width ? 1 : b.width > a.width ? -1 : 0
          })
          let f = 0
          let d
          let i
          for (i = 0; i < elastic.length; i++) {
            f += elastic[i].width / elastic[0].width
          }
          d = delta / f
          for (i = elastic.length - 1; i >= 0; i--) {
            elastic[i].width =
              elastic[i].width +
              Math.trunc((elastic[i].width / elastic[0].width) * d)
          }
        } else {
          elastic[0].width += delta
        }
      }
    },
    scrollToVisible(idx, theId) {
      const vm = this

      if (theId === vm.loptions.id) {
        let hTr = 27 //vm.body.rows[0].clientHeight
        let posTr = idx * hTr
        let delta = posTr - vm.overflow.clientHeight
        if (delta > 0) {
          vm.overflow.scrollTop = delta + vm.overflow.clientHeight / 2
        }
      }
    },
    getWindowSize(event) {
      const vm = this
      vm.windowHeight = document.documentElement.clientHeight
      //vm.windowWidth = document.documentElement.clientWidth;
      vm.windowWidth = vm.container.clientWidth
      // if(vm.options.isResizeable) {
      vm.recalcColumnsSize()
      // }
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.getWindowSize)
    },
  },
}
</script>
<style>
.table-header {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 12px;
  font-weight: bold;
}

.table-body {
  font-family: Arial, Helvetica, sans-serif;
  font-size: 12px;
  border-right: 1px solid #bdbdbd;
}

.table-body-wrapper {
  overflow-y: auto;
  height: 100%;
}

.left_align {
  text-align: left !important;
}

.right_align {
  text-align: right !important;
}

.center_align {
  text-align: center !important;
}

.cell {
  padding: 4px;
  border: 1px solid #ddd;
}

.isSelected {
  background: lightgray;
}

#right-click-menu {
  background: #fafafa;
  border: 1px solid #bdbdbd;
  box-shadow: 0 2px 2px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.2),
    0 1px 5px 0 rgba(0, 0, 0, 0.12);
  display: block;
  list-style: none;
  margin: 0;
  padding: 0;
  position: absolute;
  width: 350px;
  z-index: 999999;
}

#context-menu li {
  border-bottom: 1px solid #e0e0e0;
  margin: 0;
  padding: 5px 35px;
}

#context-menu li:last-child {
  border-bottom: none;
}

#context-menu li:hover {
  background: #1e88e5;
  color: #fafafa;
}
.trunc {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
